module.exports = __webpack_public_path__ + "fonts/Flaticon.ttf?0e11ad786f3ce57016dc57c5d28af679";